import { requireBetaFeatures } from '../../../../common/utils/requireBetaFeatures';

// @ngInject
const config = ($stateProvider) => {
  $stateProvider
    .state('variant.inquiry', {
      controller: 'InquiryController as vm',
      resolve: { betaFeatures: requireBetaFeatures },
      parent: 'variant',
      url: '/inquiry?branchId&supplierId&status',
      templateUrl: 'main/article/variant/inquiry/inquiry.tpl.html',
      data: { pageTitle: 'Inquiry' },
    })
    .state('variant.inquiry.detail', {
      parent: 'variant',
      url: '/inquiry/{inquiryId:[0-9]{1,11}}',
      templateUrl: 'main/article/variant/inquiry/inquiryDetails.tpl.html',
      resolve: {
        betaFeatures: requireBetaFeatures,
        inquiryId: /* @ngInject */ ($stateParams) =>
          parseInt($stateParams.inquiryId, 10),
        variantId: /* @ngInject */ ($stateParams) =>
          parseInt($stateParams.variantId, 10),
      },
      data: { pageTitle: 'Inquiry Detail' },
    });
};

class InquiryController {
  constructor($rootScope, $stateParams, variant) {
    'ngInject';

    this.variant = variant;
    this.article = variant.article;
    this.initialBranchId = $stateParams.branchId
      ? parseInt($stateParams.branchId, 10)
      : undefined;
    this.initialSupplierId = $stateParams.supplierId
      ? parseInt($stateParams.supplierId, 10)
      : undefined;
    this.initialLifecycle = ['all', 'open', 'sent', 'accepted'].includes(
      $stateParams.status,
    )
      ? $stateParams.status
      : 'all';

    $rootScope.pageTitle = `${this.article.itemCode || ''} - Inquiry`;
    $rootScope.breadcrumbContext = {
      tabName: 'Inquiry',
      tabState: 'variant.inquiry',
      entityName: null,
    };

    this.nodeGroup = {
      nodeXValues: this.article.nodeXValues,
      nodeYValues: this.article.nodeYValues,
    };
  }
}

angular
  .module('main.article.variant.inquiry', [])
  .config(config)
  .controller('InquiryController', InquiryController);
